package empiresmp.feature.shop.backend.model

import kotlinx.serialization.Serializable

@Serializable
value class PreCheckId(val id: Int)
